import { render } from "./BaseDialog.vue?vue&type=template&id=56609448&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=56609448&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56609448"

export default script